import { createAction } from 'redux-act'

export const fetchExchangeRate = createAction('Fetch Current Exchange Rate')
export const fetchExchangeRateSuccessful = createAction('Fetch Current Exchange Rate')
export const fetchExchangeRateFailure = createAction('Fetch Current Exchange Rate')

export const updateExchangeRate = createAction('Update Recorded Exchange Rate')
